import React from 'react';
import { useTranslation } from "react-i18next";

const AccessDeniedPage: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div
      style={{
        textAlign: 'center',
        marginTop: 50,
        direction: i18n.language === 'ar' || i18n.language === 'ckb' ? 'rtl' : 'ltr',
      }}
    >
      <h1>{t('access_denied_title')}</h1>
      <p>{t('access_denied_message')}</p>
    </div>
  );
};

export default AccessDeniedPage;
